import type Highcharts from "highcharts";

import { TBaseSerie } from "@/components/ui/chart/types/common-series.type";
import { IAxisAdapter, ICommonAxisAdapterOption } from "@/utils/chart/adapters/types/common-adapter.type";
import { EPrefixSymbol } from "@/utils/translation-utils";

export interface IYAxisAdapterOptions extends ICommonAxisAdapterOption {
  format: string;
  prefixSymbol: EPrefixSymbol;
}

export function YAxisAdapter(opts: Partial<IYAxisAdapterOptions> = {}): IAxisAdapter {
  return {
    adapt(data: TBaseSerie): Array<Highcharts.AxisOptions> {
      return [
        {
          id: data.unit,
          title: {
            text: "",
          },
          labels: {
            format: opts.format ?? `{value} ${opts.prefixSymbol ?? ""}${data.unit}`,
          },
          opposite: opts.opposite,
        },
      ];
    },
  };
}
